import { EmailCard } from "@/components/EmailCard";
import { TimetableCard } from "@/components/TimetableCard";
import { KitCard } from "@/components/KitCard";
import { NotifyCard } from "@/components/NotifyCard";
import { TermDatesCard } from "@/components/TermDatesCard";
import { InviteCard, ShareTimetableCard } from "@/components/ShareCards";
import { CalendarSyncCard, BedtimeCard, WeeklyReportCard } from "@/components/SettingsExtras";
import { YearGroupCard, JobRoleCard } from "@/components/YearGroup";
import { PasswordCard } from "@/components/PasswordCard";
import { PremiumCard } from "@/pages/PaymentResult";
import { MilestonesCard } from "@/components/StreakBadge";
import { MeetingsCard } from "@/components/MeetingsCard";
import { EditionCard } from "@/components/EditionCard";
import { useEdition } from "@/lib/edition";

export default function Connections() {
  const { corp, w } = useEdition();
  return (
    <main data-testid="connections-page" className="mx-auto max-w-5xl px-4 sm:px-6 py-8 sm:py-12 space-y-8">
      <div>
        <p className="eyebrow">Settings</p>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-none">Make it yours</h1>
        <p className="mt-3 text-slate-600">{w("Your timetable, kit list, reminders and links.", "Your work schedule, checklist, reminders and links.")}</p>
      </div>
      <MilestonesCard />
      <div className="grid gap-4 lg:grid-cols-2">
        {corp ? <JobRoleCard /> : <YearGroupCard />}
        {corp ? <MeetingsCard /> : <TimetableCard />}
        <TermDatesCard />
        <KitCard />
        <NotifyCard />
        <BedtimeCard />
        <EmailCard />
        <WeeklyReportCard />
        <CalendarSyncCard />
        <ShareTimetableCard onImported={() => window.location.reload()} />
        <InviteCard />
        <PasswordCard />
        <PremiumCard />
        <EditionCard />
      </div>
    </main>
  );
}
